import { Injectable, Inject } from '@angular/core';
import { HttpParams, HttpClient } from '@angular/common/http';
import { Address } from '../../../Models/address';
import { StreetMapLevelEnum } from 'src/app/enums/street-map-level-enum';

@Injectable()
export class OpenStreetMapService {
  nominatimUrl: string = 'https://nominatim.openstreetmap.org/search';
  openCageDataUrl: string = 'https://api.opencagedata.com/geocode/v1/google-v3-json';

  constructor(private http: HttpClient) { }

  getCordenadasByText(address: string): any {
    let addressParam = address;
    let params = new HttpParams();
    params = params.append('q', addressParam);
    params = params.append('polygon', '1');
    params = params.append('addressdetails', '1');
    params = params.append('format', 'json');
    return this.http.get(this.nominatimUrl, { params: params });
  }
  getCordenadasByAddress(address: Address): any {
    let addressParam = '' + address.street + '+' + address.extNumber + '+' + address.state + '+' + address.zipCode + '+' + address.country;
    let params = new HttpParams();
    params = params.append('q', addressParam);
    params = params.append('polygon', '1');
    params = params.append('addressdetails', '1');
    params = params.append('format', 'json');
    return this.http.get(this.nominatimUrl, { params: params });
  }

  getCoordinatesByAddress(address: Address, fields: string[]) {
    let params = new HttpParams();
    let filter = this.transformParams(address, fields, '+');
    // console.log(filter);
    params = params.append('q', filter);
    params = params.append('polygon', '1');
    params = params.append('addressdetails', '1');
    params = params.append('format', 'json');
    return this.http.get(this.nominatimUrl, { params: params });
  }

  getCoordinatesByAddressOpen(address: Address, fields: string[]) {
    let params = new HttpParams();
    let filter = this.transformParams(address, fields, ',');
    params = params.append('address', filter);
    params = params.append('limit', '5');
    params = params.append('min_confidence', '8');
    params = params.append('pretty', '1');
    params = params.append('key', '6239237e5eea4bf1bb6b6459e347f426');
    return this.http.get(this.openCageDataUrl, {params: params});
  }

  private transformParams(address: Address, fields: string[], separator: string): string {
    let result: string = '';

    for(let s in fields) {
      if(result) { 
        if(fields[s] == 'street') {
          result += ' ';
        } else {
          result += separator;
        }
      }
      if(address[fields[s]] && address[fields[s]] !== 'undefined' && address[fields[s]] !== undefined) { result += address[fields[s]]; }
    }
    
    return result;
  }
}
